import React, { useMemo } from 'react';
import classNames from 'classnames';

import { FormattedMessage } from 'react-intl';
import styles from './Footer.module.css';
import GdprBanner from '@/lib/utils/gdpr';

type FooterProps = {
  isLight?: boolean;
};

export default function Footer({ isLight = false }: FooterProps): React.ReactElement {
  const currentYear = useMemo(() => new Date().getFullYear(), []);

  const openGdpr = () => {
    const gdprBanner = GdprBanner.getInstance();

    gdprBanner?.show();
  };

  return (
    <footer className={classNames(
      styles.footer,
      isLight ? styles['footer--light'] : styles['footer--dark'],
    )}
    >
      <p>
        <FormattedMessage id="footer.rights_text" values={{ currentYear }} />
      </p>
      <p>
        <FormattedMessage
          id="footer.privacy_policy"
          values={{
            a: (chunk) => (
              <a
                className={styles.footer__link}
                href="https://x.la/privacy-policy"
                target="_blank"
                rel="noreferrer noopener"
              >
                {chunk}
              </a>
            ),
          }}
        />
      </p>
      <p>
        <FormattedMessage
          id="footer.cookie_settings"
          values={{
          button: (text) => (
            <button
              className={styles.footer__link}
              onClick={openGdpr}
            >
              {text}
            </button>
          ),
        }}
        />
      </p>
    </footer>
  );
}
